module.exports = __webpack_public_path__ + "static/media/loc-khong-khi-active.d33c8825.svg";